import axios from 'axios'

const apiPortalSky = axios.create({
  // Conexao API
  //baseURL: 'https://localhost:44360/api/v1/',
  baseURL: 'https://portalskyapi.vapza.com.br/api/v1/',
  //baseURL: 'https://portalskyapihomolog.vapza.com.br/api/v1/',
})
export default apiPortalSky
